import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FilterButton,
  SaveFilterBlock
} from 'components/common/Elements/Elements';
import InputSearch from 'components/common/forms/InputSearch/InputSearch';

import FiltersBlock from './FiltersBlock/FiltersBlock';
import { defaultFilters, defaultNavigation } from '../helpers/config';
import { useNetworkRolloutDataGrid } from '../helpers/useNetworkRolloutDataGrid';
import { useTableSettings } from '../helpers/tableSettings';

import createClasses from './styles';

interface NetRolloutFiltersProps {
  useDataGridResultProps: ReturnType<typeof useNetworkRolloutDataGrid>;
}

const NetRolloutFilters = (props: NetRolloutFiltersProps) => {
  const { useDataGridResultProps } = props;
  const classes = createClasses();

  const { t } = useTranslation(['activity']);

  const {
    setFilter,
    filter,
    loaderTable,
    startFilter,
    setStartFilter,
    handleFilterInput,
    filterButton,
    setFilterButton,
    handleFilterButton,
    onClearSearch,
    filterBackend,
    setFilterBackend,
    visibleFilterSave,
    setVisibleFilterSave,
    visibleFilterEdit,
    setVisibleFilterEdit,
    changeFilter,
    setChangeFilter,
    trigerResetDatePicker,
    setTrigerResetDatePicker,
    tableConf,
    setTableConf,
    filters,
    selectLoader,
    triggerSaveTableSettings,
    resetAllfilters
  } = useDataGridResultProps;

  const { tableConfig } = useTableSettings();

  return (
    <>
      <div className={classes.filters_main}>
        <InputSearch
          placeholder={t('activity:filters.SEARCH_PLACEHOLDER_NETWORK_ROLLOUT')}
          value={filter.search}
          onChange={handleFilterInput}
          onClearSearch={onClearSearch}
          className={classes.filter}
          disabled={loaderTable}
        />
        <FilterButton active={filterButton} onClick={handleFilterButton} />
        <SaveFilterBlock
          setFilterButton={setFilterButton}
          visibleFilterSave={visibleFilterSave}
          setVisibleFilterSave={setVisibleFilterSave}
          visibleFilterEdit={visibleFilterEdit}
          setVisibleFilterEdit={setVisibleFilterEdit}
          filter={filter}
          setFilter={setFilter}
          filterBackend={filterBackend}
          setFilterBackend={setFilterBackend}
          changeFilter={changeFilter}
          setChangeFilter={setChangeFilter}
          resetAllfilters={resetAllfilters}
          defaultNavigation={defaultNavigation}
          trigerResetDatePicker={trigerResetDatePicker}
          setTrigerResetDatePicker={setTrigerResetDatePicker}
          startFilter={startFilter}
          setStartFilter={setStartFilter}
          defaultFilters={defaultFilters}
          tableConf={tableConf}
          defaulTableConf={tableConfig}
          setTableConf={setTableConf}
          triggerSaveTableSettings={triggerSaveTableSettings}
        />
      </div>

      <FiltersBlock
        filter={filter}
        setFilter={setFilter}
        startFilter={startFilter}
        setStartFilter={setStartFilter}
        filters={filters}
        filterButton={filterButton}
        trigerResetDatePicker={trigerResetDatePicker}
        resetAllfilters={resetAllfilters}
        selectLoader={selectLoader}
        setVisibleFilterSave={setVisibleFilterSave}
        setVisibleFilterEdit={setVisibleFilterEdit}
        changeFilter={changeFilter}
      />
    </>
  );
};

export default NetRolloutFilters;
